import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Allow distinguishing between open and close toggle events for details tags like this:
//
//   <details data-action="toggle->ctr#onOpen:open"></details>
//   <details data-action="toggle->ctr#onClose:!open"></details>
//
// See https://stimulus.hotwired.dev/reference/actions#options
application.registerActionOption('open', ({ event, value }) => {
  if (event.type == 'toggle') {
    return event.target.open == value;
  } else {
    return true;
  }
});

// With ":outside" you can react to events that don't target the current element:
//
//   <div data-action="click@window:outside->ctr#onOutsideClick"></div>
//
application.registerActionOption(
  'outside',
  ({ event, element }) => !element.contains(event.target),
);

// With ":valueEmpty", the action is only called if the elements value is empty.
application.registerActionOption(
  'valueEmpty',
  ({ event, element }) => element.value == '',
);

// With ":valueNotEmpty", the action is only called if the elements value is not empty.
application.registerActionOption(
  'valueNotEmpty',
  ({ event, element }) => element.value != '',
);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };
